import React from "react";
import * as DOMPurify from 'dompurify';

const Topbar= ({ htmldata }) => {
    const sanitizedContent = DOMPurify.sanitize(htmldata, {
        ADD_TAGS: ['iframe','embed'],
        ADD_ATTR: ['src','target','rel'],        
      });

    return (  
        <div className="header-top second-header d-none d-md-block" dangerouslySetInnerHTML={{__html: sanitizedContent}}></div>        
    );
}
export default Topbar;